import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface NewsletterModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function NewsletterModal({
  isOpen,
  onClose
}: NewsletterModalProps) {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => {
        onClose();
        setTimeout(() => {
          setIsSubmitted(false);
          setEmail('');
        }, 500);
      }, 2000);
    }
  };
  return <AnimatePresence data-id="element-231">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-232">
          <motion.div className="absolute inset-0 bg-brand-dark/80 backdrop-blur-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} data-id="element-233" />
          <motion.div className="bg-white w-full max-w-md p-10 relative z-10 rounded-sm shadow-2xl overflow-hidden" initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} data-id="element-234">
            {/* Noise Overlay */}
            <div className="absolute inset-0 bg-noise opacity-10 pointer-events-none" data-id="element-235"></div>

            <button onClick={onClose} className="absolute top-4 right-4 text-brand-dark/50 hover:text-brand-red transition-colors z-20" data-id="element-236">
              <X size={24} data-id="element-237" />
            </button>

            <div className="relative z-10 text-center" data-id="element-238">
              {!isSubmitted ? <>
                  <h3 className="text-3xl font-serif text-brand-dark mb-4" data-id="element-239">
                    Join The Circle
                  </h3>
                  <p className="text-brand-dark/70 font-light mb-8 text-sm leading-relaxed" data-id="element-240">
                    Subscribe to our newsletter to receive exclusive updates on
                    new concepts, seasonal menus, and private events.
                  </p>

                  <form className="space-y-6" onSubmit={handleSubmit} data-id="element-241">
                    <div data-id="element-242">
                      <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email Address" required className="w-full bg-transparent border-b border-brand-dark/20 py-3 text-brand-dark placeholder:text-brand-dark/40 focus:outline-none focus:border-brand-gold transition-colors text-center" data-id="element-243" />
                    </div>
                    <button type="submit" className="w-full bg-brand-dark text-white py-4 text-sm uppercase tracking-[0.2em] hover:bg-brand-red transition-colors" data-id="element-244">
                      Subscribe
                    </button>
                  </form>
                </> : <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="py-8" data-id="element-245">
                  <div className="w-16 h-16 bg-brand-gold/20 text-brand-gold rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-246">
                    <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-247">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-248" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-serif text-brand-dark mb-2" data-id="element-249">
                    Welcome to The Circle
                  </h3>
                  <p className="text-brand-dark/70 font-light text-sm" data-id="element-250">
                    Thank you for subscribing.
                  </p>
                </motion.div>}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}